import { exchange } from '../../utilities/constants';
import { formatNumber } from '../../utilities/formatHelpers';

/* eslint-disable import/prefer-default-export */
export const calculateRewardsHelper = (apr, amount) => {
  const result = {
    daily: 0,
    monthly: 0,
    annual: 0,
  };

  if (apr > 0 && amount > 0) {
    const annualReward = amount * (apr / 100);
    const dailyReward = annualReward * (1 / 365);
    const monthlyReward = annualReward * (30 / 365);

    result.daily = formatNumber(dailyReward, exchange.CRYPTO_VALUE);
    result.monthly = formatNumber(monthlyReward, exchange.CRYPTO_VALUE);
    result.annual = formatNumber(annualReward, exchange.CRYPTO_VALUE);
  }

  return result;
};
